import Travel from '@/models/carbon/Travel'
import {
  intConverter,
  booleanConverter,
  tagsConverter
} from '@/utils/parser.js'

export default function (positionDictionary, purposeDictionary) {
  let positiond = positionDictionary
  let purposed = purposeDictionary
  return {
    meta: {
      name: 'ekocentral GES',
      check: function (fields) {
        return fields.includes('# mission')
      }
    },
    names: {
      pattern: /(# |Num.ro |)(mission|trip)/i,
      required: true, // names must be set (no default)
      converter: function (value) {
        return [value]
      }
    },
    date: {
      pattern: /(date|departure date|date de d.part)/i,
      required: true,
      default: null // not really important (isn't kept in the db)
    },
    departureCity: {
      pattern: /(departure city|ville de d.part)/i,
      required: true,
      default: null // will be marked as invalid
    },
    departureCountry: {
      pattern: /(departure country|country of departure|pays de d.part)/i,
      required: true,
      converter: function (value) {
        return Travel.iso3166Country(value)
      },
      default: null // will be marked as invalid
    },
    destinationCity: {
      pattern: /(destination city|ville de destination)/i,
      required: true,
      default: null // will be marked as invalid
    },
    destinationCountry: {
      pattern:
        /(destination country|country of destination|pays de destination)/i,
      required: true,
      converter: function (value) {
        return Travel.iso3166Country(value)
      },
      default: null // will be marked as invalid
    },
    transportation: {
      pattern: /(mode|moyens).*(transport|d.placement)/i,
      converter: function (value) {
        return Travel.getTransportation(value)
      },
      required: true,
      default: null // will be marked as invalid
    },
    carpooling: {
      pattern:
        /(no of persons in the car|nb de personnes dans la voiture|no of persons|nb de personnes|covoiturage|carpooling)/i,
      default: 1,
      required: true,
      converter: intConverter
    },
    isRoundTrip: {
      pattern: /(roundtrip|aller.*retour)/i,
      converter: booleanConverter,
      required: true,
      default: false // aligned with the TravelSection constructor
    },
    purpose: {
      pattern: /(purpose of the trip|purpose|motif|motif du d.placement)/i,
      converter: function (value) {
        return Travel.getPurpose(value, purposed)
      },
      default: Travel.PURPOSE_UNKNOWN
    },
    status: {
      pattern: /(agent position|position|statut.*agent|statut)/i,
      converter: function (value) {
        return Travel.getStatus(value, positiond)
      },
      default: Travel.STATUS_UNKNOWN
    },
    amount: {
      pattern: /(quantit.|nombre|amount|number)/i,
      default: 1,
      converter: intConverter
    },
    tags: {
      pattern: /(tag|tags|label|labels)/i,
      converter: tagsConverter,
      default: []
    }
  }
}
